<template>
  <div class="UiCheck" @click="$emit('input', !value)" :class="{'is-button': isButton}">
    <div class="box">
      <i class="fas fa-check-square is-checked" v-if="value"></i>
      <i class="fas fa-square" v-else></i>
    </div>
    <div class="body" v-if="this.$slots.default"><slot /></div>
  </div>
</template>

<script>
export default {
  name: 'UiCheck',
  props: {
    isButton: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped lang="scss">
.UiCheck {
  display: flex;
  align-items: center;
  cursor: pointer;

  &.is-button {
    box-sizing: border-box;
    height: 100%;
    padding: 6px 9px;
    border: 1px solid $light;
    border-radius: $round;
    background: $white;
  }
}

.box {
  font-size: 18px;
  width: 20px;
  color: $light;

  i.is-checked {
    color: $primary;
  }
}

.body {
  flex: 1;
  margin-left: 5px;
}
</style>
